import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { AuthContext } from "../AuthProvider";
import CONFIGURACIONES from "../../../util/constants";

const PageWrapper = ({showSpinnerLoader, getDataUser}) => {
    const { checkToken, getUser } = useContext(AuthContext);

    return (
        <div className="page-wrapper">
            <div className="page-breadcrumb">
                <div className="row">
                    {/* <div className="col-sm-12 col-md-10 align-self-center">
                        <div className="form-group row">
                            <label htmlFor="zonaId" className="col-sm-2 text-right control-label col-form-label">Zona <span className="text-danger">*</span></label>
                            <div className="col-sm-3">
                                <select 
                                    className="form-control" id="zonaId" 
                                    placeholder="" defaultValue={""}
                                >
                                {
                                    CONFIGURACIONES.INIT.LIST.GENEROS.map((el, index) => (
                                        <option key={index} value={el.id}>{el.nombre}</option>
                                    ))
                                }
                                </select>   
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="agenciaId" className="col-sm-2 text-right control-label col-form-label">Agencia <span className="text-danger">*</span></label>
                            <div className="col-sm-3">
                                <select 
                                    className="form-control" id="agenciaId" 
                                    placeholder="" defaultValue={""}
                                >
                                {
                                    CONFIGURACIONES.INIT.LIST.GENEROS.map((el, index) => (
                                        <option key={index} value={el.id}>{el.nombre}</option>
                                    ))
                                }
                                </select>  
                            </div> 
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-2 align-self-center">
                        
                    </div> */}
                </div>
            </div>
        
            <div className="container-fluid">
                <Outlet context={{checkSession: checkToken(), showSpinnerLoader, getUser }} />
            </div>
            <footer className="footer text-center">
                Todos los derechos reservados por FastCapital. Diseñado y Desarrollado por <a href="#">Área de Tecnología de Información</a>.
            </footer>
        </div>
    )
}

export default PageWrapper;